import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import { UsuariosAdapter } from '../../../../../infraestructure/persistence/rest/UsuariosAdapter';
import { ListadoUsuariosDelegado } from './lista';
import { EuiLoadingSpinner } from '@elastic/eui';


const UsuariosDelegadoContainer = (props:any) => {

	const api = new UsuariosAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	let [ data, setData ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState(false)
	let result: any;

    useEffect(()=>{getData()},[])
	useEffect(() => {setIsLoading(false)}, [ data ]);

	const getData = async () => {
        setIsLoading(true);
		try {
			result = (props.type === 'DEL') ? await api.ListarDelegadosUsuario(props.selected.dni) : await api.ListarUsuariosDelegado();
			if(result.data && result.data!=="")
			{
				setData([ ...result.data ] || []);
			}else{resultError()}
		} catch (error) {
			let exception = ServerErrorMessage(error);
			exceptionError(exception)
		}
	};

    return isLoading ? <EuiLoadingSpinner size="xl" /> : <ListadoUsuariosDelegado data={data} {...props}/>
};

export default UsuariosDelegadoContainer;